import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "屏幕截图信息", -1)

import ScreenshotWindow from '@/components/screenshot/ScreenshotWindow.vue';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "ScreenshotTable",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(ScreenshotWindow)
  ], 64))
}
}

})